import type { CaptureContext } from "@sentry/core";
import * as Sentry from "@sentry/react";
import posthog, { type CaptureResult } from "posthog-js";

type ErrorCaptureResult = {
  sentryEventId: string;
  posthogResult: CaptureResult | undefined;
};

export const captureException = (error: Error | unknown, context?: CaptureContext): ErrorCaptureResult => {
  const sentryEventId = Sentry.captureException(error, context);

  const posthogResult = posthog.captureException(error, {
    ...context,
    sentry_event_id: sentryEventId,
  });

  return {
    sentryEventId,
    posthogResult,
  };
};

export const captureMessage = (message: string, context?: CaptureContext): ErrorCaptureResult => {
  const sentryEventId = Sentry.captureMessage(message, context);

  const posthogResult = posthog.captureException(new Error(message), {
    ...context,
    sentry_event_id: sentryEventId,
  });

  return {
    sentryEventId,
    posthogResult,
  };
};
